import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { SCREEN_API_HEADER_OVERRIDES } from '@shared-lib/foundry-services/common-api/screen-api-http-context';

let lastRoleTraceSignature = '';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const keycloakInstance = keycloak.getKeycloakInstance();
  const token = keycloakInstance.token;

  if (token) {
    const claims = keycloakInstance.tokenParsed as any;
    const realmRoles = Array.isArray(claims?.realm_access?.roles)
      ? claims.realm_access.roles.map((role: unknown) => String(role))
      : [];
    const clientRoles = Object.fromEntries(
      Object.entries((claims?.resource_access || {}) as Record<string, any>)
        .map(([clientId, access]) => [
          clientId,
          Array.isArray(access?.roles) ? access.roles.map((role: unknown) => String(role)) : [],
        ]),
    );
    let resolvedRoles: string[] = [];
    try {
      resolvedRoles = keycloak.getUserRoles(true) || [];
    } catch {
      resolvedRoles = [];
    }

    const roleTraceSignature = JSON.stringify({ realmRoles, clientRoles, resolvedRoles });
    if (roleTraceSignature !== lastRoleTraceSignature) {
      lastRoleTraceSignature = roleTraceSignature;
      console.info('[AUTH_ROLE_TRACE][AUTH_HEADERS_INTERCEPTOR]', {
        username: String(claims?.preferred_username || claims?.username || ''),
        realmRoles,
        clientRoles,
        resolvedRoles,
        firstAuthorizedRequestUrl: req.url,
      });
    }
  }

  const headers: Record<string, string> = {
    Accept: 'application/json',
  };
  // Let the browser generate multipart/form-data with its required boundary.
  // For all other requests, preserve the existing JSON content type.
  if (!(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

//   if (
//   (req.url.includes('/off_highway/dashboard/totalOpportunity/cagr') ||
//    req.url.includes('/off_highway/dashboard/totalOpportunity/validate')) &&
//   token
// ) {
//   headers['Authorization'] = `Bearer ${token}`;
// }

if(token){
    headers['Authorization'] = `Bearer ${token}`;
}

  // Screen APIs inherit defaults unless the user explicitly supplied that header.
  // HttpHeaders.has is case-insensitive, so accept and Accept behave identically.
  if (req.context.get(SCREEN_API_HEADER_OVERRIDES)) {
    for (const name of Object.keys(headers)) {
      if (req.headers.has(name)) delete headers[name];
    }
  }

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
